<template>
  <div class="col" :class='"m"+w'>
  <slot></slot>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
    }
  },
  created() {
  	
  },
  mounted(){
  	var elemss = document.querySelectorAll('.dropdown-trigger');
    M.Dropdown.init(elemss, {closeOnClick: this.close});
  },
  methods: {
  },
  props: {
    'close': {
      default: false,
      type: Boolean
    },
    w: {
      default: 2,
    }
  }
}
</script>

<style scoped>
</style>
